import { useState } from "react";

function ReplyForm({ onReply }) {
  const [replyText, setReplyText] = useState("");

  const handleSubmit = () => {
    onReply(replyText);
    setReplyText("");
  };

  return (
    <div className="mt-3 flex space-x-2">
      <input
        type="text"
        value={replyText}
        onChange={(e) => setReplyText(e.target.value)}
        className="flex-1 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded px-2 py-1 text-sm"
        placeholder="Responder..."
      />
      <button onClick={handleSubmit} className="text-sm text-blue-600 hover:underline">
        Enviar
      </button>
    </div>
  );
}

export default ReplyForm;
